import "./App.css";
import { useEffect } from "react";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { ConfigProvider } from "antd";
import MainLayout from "./components/MainLayout";
import Dashboard from "./components/Dashboard";
import Authentication from "./components/Authentication";
import Authorization from "./components/Authorization";
import PageNotFound from "./components/PageNotFound";
import Login from "./components/Login";
import UserTable from "./components/config/user/UserTable";
import CustomerTable from "./components/config/customer/CustomerTable";
import AddCustomer from "./components/config/customer/AddCustomer";
import CategoryTable from "./components/config/category/CategoryTable";
import SubcategoryTable from "./components/config/subcategory/SubcategoryTable";
import ProductTable from "./components/config/product/ProductTable";
import AddProduct from "./components/config/product/AddProduct";
import QuotationTable from "./components/config/quotation/QuotationTable";
import AddQuotation from "./components/config/quotation/AddQuotation";
import AuthorisationLetterTable from "./components/authorisation letter/AuthorisationLetterTable";
import Home from "./website/components/Home";
import HomePage from "./website/components/HomePage/HomePage";
import ProductPage from "./website/components/ProductPage/ProductPage";
import SubcategoryPage from "./website/components/Subcategory Page/SubcategoryPage";
import CategoryPage from "./website/components/Category Page/CategoryPage";
import About from "./website/components/About";
import Privacy from "./website/components/Privacy";
import ContactUs from "./website/components/HomePage/ContactUs";
import CategorySeoTable from "./seo/CategorySeoTable";
import ProductSeoTable from "./seo/ProductSeoTable";
import SubcategorySeoTable from "./seo/SubcategorySeoTable";
import MainCategorySeoTable from "./seo/MainCategorySeoTable";
import AddMainCategorySeo from "./seo/AddMainCategorySeo";
import AddSubcategorySeo from "./seo/AddSubcategorySeo";
import AddCategorySeo from "./seo/AddCategorySeo";
import AddProductSeo from "./seo/AddProductSeo";
import ProductRedirect from "./website/components/Redirects/ProductRedirect";
import SubCategoryRedirect from "./website/components/Redirects/SubCategoryRedirect";
import CategoryRedirect from "./website/components/Redirects/CategoryRedirect";
import StaticSeoTable from "./seo/StaticSeoTable";
import AddStaticSeo from "./seo/AddStaticSeo";
import SearchResultsPage from "./website/components/HomePage/SearchResultsPage";
/***************Admin *************/

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      {/* WEBSITE ROUTES */}
      <Route path="" element={<Home />}>
        <Route path="" element={<HomePage />} />
        <Route path="/about" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<ContactUs showBanner={true} />} />
        <Route path="/search" element={<SearchResultsPage />} />
        <Route
          path="/:main_category_url/:category_url/:subcategory_url/:product_url"
          element={<ProductPage />}
        />
        <Route
          path="/:main_category_url/:category_url/:subcategory_url"
          element={<SubcategoryPage />}
        />
        <Route
          path="/:main_category_url/:category_url"
          element={<CategoryPage />}
        />
        <Route
          path="/:main_category_url/:main_category_id/:category_url/:category_id/:subcategory_url/:subcategory_id/:product_url/:product_id"
          element={<ProductRedirect />}
        />
        <Route
          path="/:main_category_url/:main_category_id/:category_url/:category_id/:subcategory_url/:subcategory_id"
          element={<SubCategoryRedirect />}
        />
        <Route
          path="/:main_category_url/:main_category_id/:category_url/:category_id"
          element={<CategoryRedirect />}
        />
      </Route>

      {/* ADMIN PORTAL ROUTES */}
      <Route path="/login" element={<Login />} />

      {/* <Route path="/privacy-policy" element={<PrivacyPolicy />}></Route> */}

      <Route element={<Authentication />}>
        <Route path="portal" element={<MainLayout />}>
          <Route path="/portal/dashboard" element={<Dashboard />} />
          <Route element={<Authorization allowedRoles={["1"]} />}>
            {/* allowedRoles is array */}
            {/* all admin only routes here */}

            <Route path="/portal/setting/users" element={<UserTable />} />

            <Route
              path="/portal/setting/categories"
              element={<CategoryTable />}
            />
            <Route
              path="/portal/setting/subcategories"
              element={<SubcategoryTable />}
            />
            {/* <Route
              path="/portal/setting/category-subcategory"
              element={<CategorySubcategoryTable />}
            /> */}
            <Route path="/portal/setting/products" element={<ProductTable />} />
            <Route
              path="/portal/setting/product/add"
              element={<AddProduct />}
            />
            {/* <Route
              path="/portal/setting/accessory"
              element={<AccessoryTable />}
            /> */}
          </Route>
          <Route element={<Authorization allowedRoles={["1", "2"]} />}>
            <Route
              path="/portal/setting/customers"
              element={<CustomerTable />}
            />
            <Route
              path="/portal/setting/customer/add"
              element={<AddCustomer />}
            />
            <Route path="/portal/quotation" element={<QuotationTable />} />
            <Route path="/portal/quotation/add" element={<AddQuotation />} />
            <Route
              path="/portal/authorisation-letter"
              element={<AuthorisationLetterTable />}
            />
            <Route path="/portal/products-seo" element={<ProductSeoTable />} />
            <Route
              path="/portal/static-pages-seo"
              element={<StaticSeoTable />}
            />
            <Route
              path="/portal/categories-seo"
              element={<CategorySeoTable />}
            />
            <Route
              path="/portal/subcategories-seo"
              element={<SubcategorySeoTable />}
            />
            {/* <Route
              path="/portal/main-categories-seo"
              element={<MainCategorySeoTable />}
            /> */}
            <Route path="/portal/product-seo/add" element={<AddProductSeo />} />
            <Route
              path="/portal/product-seo/edit/:id"
              element={<AddProductSeo />}
            />
            <Route
              path="/portal/static-page-seo/add"
              element={<AddStaticSeo />}
            />
            <Route
              path="/portal/static-page-seo/edit/:id"
              element={<AddStaticSeo />}
            />
            <Route
              path="/portal/category-seo/add"
              element={<AddCategorySeo />}
            />
            <Route
              path="/portal/category-seo/edit/:id"
              element={<AddCategorySeo />}
            />
            <Route
              path="/portal/subcategory-seo/add"
              element={<AddSubcategorySeo />}
            />
            <Route
              path="/portal/subcategory-seo/edit/:id"
              element={<AddSubcategorySeo />}
            />
            <Route
              path="/portal/main-category-seo/add"
              element={<AddMainCategorySeo />}
            />
            <Route
              path="/portal/main-category-seo/edit/:id"
              element={<AddMainCategorySeo />}
            />
          </Route>
        </Route>

        <Route path="unauthorized" element={<>Unauthorized</>} />
      </Route>
      <Route path="*" element={<PageNotFound />} />
    </>
  )
);

// Advanced Protection Hook
const useAdvancedProtection = () => {
  useEffect(() => {
    let devtools = {
      open: false,
      orientation: null,
    };

    const threshold = 160;
    let warningShown = false;

    const checkDevTools = setInterval(() => {
      if (
        window.outerHeight - window.innerHeight > threshold ||
        window.outerWidth - window.innerWidth > threshold
      ) {
        if (!devtools.open) {
          devtools.open = true;
          console.clear();

          // Show warning only once per session
          if (!warningShown) {
            warningShown = true;
            // Optional: You can uncomment below to redirect users
            // window.location.href = '/unauthorized';
            // Or show a modal/alert
            // alert('Developer tools are not allowed on this website');
          }
        }
      } else {
        devtools.open = false;
      }
    }, 500);

    // Comprehensive protection handlers
    const protection = {
      // Block right-click context menu
      contextmenu: (e) => {
        e.preventDefault();
        return false;
      },

      // Block keyboard shortcuts
      keydown: (e) => {
        // F12 - Developer Tools
        if (e.key === "F12") {
          e.preventDefault();
          console.warn("F12 blocked");
          return false;
        }

        // Ctrl+Shift+I - Developer Tools
        // Ctrl+Shift+C - Element Inspector
        // Ctrl+Shift+J - Console
        if (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(e.key)) {
          e.preventDefault();
          return false;
        }

        // Ctrl+U - View Source
        if (e.ctrlKey && e.key === "u") {
          e.preventDefault();
          return false;
        }

        // Ctrl+S - Save Page
        if (e.ctrlKey && e.key === "s") {
          e.preventDefault();
          return false;
        }

        // Ctrl+A - Select All
        if (e.ctrlKey && e.key === "a") {
          e.preventDefault();
          return false;
        }

        // Ctrl+P - Print
        if (e.ctrlKey && e.key === "p") {
          e.preventDefault();
          return false;
        }
      },

      // Block text selection
      selectstart: (e) => {
        e.preventDefault();
        return false;
      },

      // Block drag and drop
      dragstart: (e) => {
        e.preventDefault();
        return false;
      },

      // Block print screen (limited effectiveness)
      keyup: (e) => {
        if (e.key === "PrintScreen") {
          navigator.clipboard.writeText("").catch(() => {});
        }
      },

      // Block copy
      copy: (e) => {
        e.preventDefault();
        return false;
      },

      // Block cut
      cut: (e) => {
        e.preventDefault();
        return false;
      },
    };

    // Add all event listeners
    Object.entries(protection).forEach(([event, handler]) => {
      document.addEventListener(event, handler, { passive: false });
    });

    // Additional protection: disable console methods (optional)
    const originalConsole = { ...console };

    // Uncomment below to disable console completely
    // console.log = console.warn = console.error = console.info = console.debug = () => {};

    // Cleanup function
    return () => {
      clearInterval(checkDevTools);

      // Remove event listeners
      Object.entries(protection).forEach(([event, handler]) => {
        document.removeEventListener(event, handler);
      });

      // Restore console (if disabled)
      // Object.assign(console, originalConsole);
    };
  }, []);
};

function App() {
  // Apply advanced protection to entire app
  useAdvancedProtection();
  useEffect(() => {
    window.prerenderReady = true;
  }, []);

  return (
    <ConfigProvider
      theme={{
        components: {
          Collapse: {
            headerBg: "rgb(20, 168, 0)",
            colorTextHeading: "rgb(255, 255, 255)",
          },
        },
        token: {
          algorithm: "compactAlgorithm",
          // Seed Token
          colorPrimary: "#1677ff",
          borderRadius: 11,
          fontFamily: "Manrope",
          colorTextBase: "#455560",
        },
      }}
    >
      <RouterProvider router={router} />
    </ConfigProvider>
  );
}

export default App;
